const swiper_1 = new Swiper('.swiper-container-video', {
  mode: 'horizontal',
  autoplay: 3000,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoHeight: false,
  spaceBetween: 30,
  slidesPerView: 1,
  slidesPerColumn: 2,
  breakpoints: {
    1200: {
      slidesPerView: 3
    },
    991: {
      slidesPerView: 3
    },
    767: {
      slidesPerView: 2
    }
  }
  
});


const swiper_2 = new Swiper('.swiper-container_1', {

  mode: 'horizontal',
  autoplay: 3000,
  scrollbar: {
    el: '.swiper-scrollbar_1',
    draggable: true
  },
  spaceBetween: 30,
  centeredSlides: true,
  slidesPerView: 1,
  initialSlide:3,
  breakpoints: {
    1200: {
      slidesPerView: 2.5
    },
    991: {
      slidesPerView: 2.5
    },
    767: {
      slidesPerView: 1
    }
  }
  
});

const swiper_3 = new Swiper('.swiper-container_benefits', {
  mode: 'horizontal',
  autoplay: {
    delay: 3000,
  },
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination_benefits',
  },
  slidesPerView: 1   
});

function openTab(evt, index) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(index).style.display = "block";
    evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
if (document.getElementById("defaultOpen") != null){
document.getElementById("defaultOpen").click();
}


function openLink(evt, href) {   
    var destination = $(href).offset().top;
    $('body,html').animate({ scrollTop: destination }, 700);
}

$(function () {
	let header = $(".site-header");
	$(window).scroll(function () {
		if ($(this).scrollTop() > 10) {
			header.addClass("fixed");
		} else {
			header.removeClass("fixed");
		}
	});
});

